import { ClipboardState, state as defaultState } from './state';
import { getters } from '@/store/modules/clipboard/getters';
import { mutations } from '@/store/modules/clipboard/mutations';
import { actions } from '@/store/modules/clipboard/actions';
import { Module } from 'vuex';
import { RootState } from '@/store/state';

export default {
  namespaced: true,
  state: defaultState(),
  actions,
  mutations,
  getters
} as Module<ClipboardState, RootState>;
